import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { OrderConfirmationItemsComponent } from '@spartacus/order/components';
import { Order, OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';

@Component({
  selector: 'gen-order-confirmation-items',
  templateUrl: './order-confirmation-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenOrderConfirmationItemsComponent extends OrderConfirmationItemsComponent implements OnDestroy {
  override order$: Observable<Order | undefined> = this.orderFacade.getOrderDetails() as Observable<Order | undefined>;
  isServicePartsEnabled: boolean;

  constructor(
    override orderFacade: OrderFacade,
    protected winRef: WindowRef,
  ) {
    super(orderFacade);
    this.isServicePartsEnabled = JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
  }
}
